import { render, staticRenderFns } from "./OpenOrdersModal.vue?vue&type=template&id=46e47b28&scoped=true"
import script from "./OpenOrdersModal.vue?vue&type=script&lang=ts"
export * from "./OpenOrdersModal.vue?vue&type=script&lang=ts"
import style0 from "./OpenOrdersModal.vue?vue&type=style&index=0&id=46e47b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e47b28",
  null
  
)

export default component.exports